import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ContentContainer } from '../../../../content-container/content-container';

@Component({
  selector: 'app-footer',
  imports: [ContentContainer],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
  socialMediaLinks = signal([
    {
      link: 'https://www.youtube.com/@code.dimension',
      icon: '/images/social/youtube.svg',
      label: 'YouTube',
    },
    {
      link: 'https://discord.gg/VFNmgxEHXF',
      icon: '/images/social/discord.svg',
      label: 'Discord',
    },
    {
      link: 'https://chat.whatsapp.com/Eo6YWjWyAgA5gdBUkXoi13',
      icon: '/images/social/whatsapp.svg',
      label: 'WhatsApp',
    },
    {
      link: 'https://www.linkedin.com/company/code-dimension/',
      icon: '/images/social/linkedin.svg',
      label: 'LinkedIn',
    },
    {
      link: 'https://www.instagram.com/codedimension_/',
      icon: '/images/social/instagram.svg',
      label: 'Instagram',
    },
    {
      link: 'https://www.tiktok.com/@codedimension',
      icon: '/images/social/tiktok.svg',
      label: 'Tiktok',
    },
  ]);

  podimensionLinks = signal([
    {
      link: 'https://www.youtube.com/playlist?list=PLXEUJjGpEX7wLV1H35P262slQfuWXJKQK',
      label: 'YouTube',
    },
    {
      link: 'https://open.spotify.com/show/6mCmhpeOn0JgpF3Wf5nvtx?si=41e1567f8442474e',
      label: 'Spotify',
    },
    {
      link: 'https://music.amazon.com/podcasts/7c318b6b-27a9-412f-b3f5-f1e92396922d/podimension',
      label: 'Amazon Music',
    },
  ]);

  aboutLinks = signal([
    { link: 'https://roadmap.codedimension.com.br/', label: 'Roadmap' },
    { link: '/quem-somos', label: 'Quem Somos' },
    { link: '/mentorias', label: 'Mentorias' },
    { link: 'https://blog.codedimension.com.br', label: 'Blog' },
    { link: '/entrar-na-comunidade', label: 'Comunidade' },
    { link: '/politica-de-privacidade', label: 'Privacidade' },
  ]);
}
